class StrategyListener

	constructor: ->
		@listeners = []

	listen: (type, context) ->
		@listeners[type] = context

	listening: (type) ->
		return true if @listeners[type]
